import { APIClient } from '@/services'
import { Profile } from './views'
import { analytics } from '@/services/analytics'

export function useDeleteAccount() {
  const onDeleteAccount = async (id: Profile['id']) => {
    APIClient.Session.logout(true, true)
    APIClient.Session.deleteProfile(id)
    analytics?.track?.('delete_account')
  }

  return {
    onDeleteAccount
  }
}
